import React from "react";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import Beam from "./Beam";
import { DoorGlassMaterial } from "shared/utils/door";
import {
  defaultDoorWidth,
  defaultSideFrameWidth,
  defaultUHandleConnectorXPosition,
  defaultUHandleHeight,
  defaultUHandleZPosition,
} from "shared/utils/doorSceneConstants";
import { getGeometryBounds2D, getOpeningAnchoredX } from "./openingGeometry";

interface HandleProps {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
}

const UHandleFront: React.FC<HandleProps> = ({
  doorNodes,
  materials,
  index,
}: HandleProps) => {
  const {
    getConfigurationAnchorBeams,
    getConfigurationWidth,
    getConfigurationColor,
  } = useConfigurationOptionsContext();

  const anchorBeams = getConfigurationAnchorBeams();
  const topBeam = anchorBeams[0] ?? null;
  const bottomBeam = anchorBeams[1] ?? null;
  const topBeamY = (topBeam?.height ?? 1280) / 1000;
  const bottomBeamY = (bottomBeam?.height ?? 640) / 1000;
  const width = getConfigurationWidth(index);
  const glassBounds = getGeometryBounds2D(doorNodes.glass.geometry);
  const defaultConnectorX =
    (defaultDoorWidth / 2 -
      (defaultSideFrameWidth + defaultUHandleConnectorXPosition)) /
    1000;
  const handleConnectorX = getOpeningAnchoredX({
    glassBounds,
    width,
    defaultX: defaultConnectorX,
    reverse: true,
  });
  const handleScaleY =
    (topBeamY * 1000 - bottomBeamY * 1000) / defaultUHandleHeight;
  const handlePositionY = bottomBeamY + (topBeamY - bottomBeamY) / 2;

  return (
    <group>
      {/* Handle top beam */}
      <Beam
        id={topBeam?.id ?? null}
        key={`u-handle-beam-0`}
        doorNodes={doorNodes}
        materials={materials}
        width={width}
        height={topBeamY}
      />
      {/* Handle bottom beam */}
      <Beam
        id={bottomBeam?.id ?? null}
        key={`u-handle-beam-1`}
        doorNodes={doorNodes}
        materials={materials}
        width={width}
        height={bottomBeamY}
      />
      {/* Handle top part - front */}
      <mesh
        geometry={doorNodes["handle_ugreep_handle_0"].geometry}
        material={materials[getConfigurationColor()]}
        position={[handleConnectorX, topBeamY, 0.022]}
      ></mesh>
      {/* Handle middle part - front */}
      <mesh
        geometry={doorNodes["handle_ugreep_handle_1"].geometry}
        material={materials[getConfigurationColor()]}
        position={[
          handleConnectorX,
          handlePositionY,
          defaultUHandleZPosition / 1000,
        ]}
        scale={[1, handleScaleY, 1]}
      ></mesh>
      {/* Handle bottom part - front */}
      <mesh
        geometry={doorNodes["handle_ugreep_handle_2"].geometry}
        material={materials[getConfigurationColor()]}
        position={[handleConnectorX, bottomBeamY, 0.022]}
      ></mesh>
    </group>
  );
};

export default UHandleFront;
